import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { RevizyonEditComponent } from './revizyon-edit.component';
import { RevizyonKartComponent } from './revizyon-kart.component';

@DinamikBilesen({
  id: 'revizyon',
  baslik: 'Revizyon',
  aciklama: 'Teklif revizyonu ekle',
  ikon: 'history',
  kategori: 'satis',
})
class Revizyon {
  paylas_kutusu = RevizyonEditComponent;
  paylasilmis_kart = RevizyonKartComponent;
}
